import { uriAddSearchParams } from 'features/common/utils/navigationUtils'
import { ProviderType } from 'features/connections/types'
import { Formats } from 'features/maps/types'
import { Map, MapPrivacy } from 'features/maps/types'

export interface NewMapWithLayerProps {
  source: string
  provider: ProviderType
  connectionId: string
  connectionName: string
  type: string
  title: string
  format: Formats
  geoColumn?: string
  columns?: string[] | null
}

export const BuilderPaths = {
  NewEmptyMap: '/builder',
  NewMapWithLayer: ({
    source,
    provider,
    connectionName,
    type,
    title,
    format,
    geoColumn,
    columns
  }: NewMapWithLayerProps) =>
    uriAddSearchParams('/builder', {
      source,
      provider,
      connection: connectionName,
      type,
      format,
      ...(geoColumn && { geoColumn }),
      ...(columns && { columns: columns.join(',') }),
      title
    }),
  EditMap: (mapId: string) => `/builder/${mapId}`,
  PublicMap: (mapId: string) => `/map/${mapId}`,
  ViewMap: (mapId: string) => `/viewer/${mapId}`
}

export function isPublicMapUrl(path?: string) {
  if (!path) {
    path = window.location.pathname
  }
  return path.startsWith('/map/')
}

export function getMapSharingUrl(map: Map) {
  if (!map.id) {
    return ''
  } else if (map.privacy === MapPrivacy.Public) {
    return `${window.location.origin}${BuilderPaths.PublicMap(map.id)}`
  } else if (map.privacy === MapPrivacy.Shared) {
    return `${window.location.origin}${BuilderPaths.ViewMap(map.id)}`
  } else {
    return ''
  }
}

export function isInBuilder(path?: string | undefined) {
  if (!path) {
    path = window.location.pathname
  }
  return path === '/builder' || path.startsWith('/builder/') || path.startsWith('/map/') || path.startsWith('/viewer/')
}

export function isInViewer(path?: string | undefined) {
  if (!path) {
    path = window.location.pathname
  }
  return path.startsWith('/viewer/')
}
